import React from "react";
import { LeadNotesDisplayContainer } from "./LeadNotes";
import { useTranslation } from "react-i18next";
import { InfoBlockExtraSmall } from "../../../components/InfoBlocks/InfoBlocks";
import type { RejectionNote } from "../../../types/types";
import { formatDateTime } from "../../../util/util";

export type LeadRejectionCardProps = {
  rejection_note: RejectionNote;
};

/**
 * display lead rejection messages if they exist.
 */
export function LeadRejectionCard({
  rejection_note: {
    message,
    message_for_buyer,
    modified_by,
    modified_at,
    note_type,
  },
}: LeadRejectionCardProps) {
  const { t } = useTranslation();

  const statusMessage =
    note_type === "rejection_message"
      ? t("This lead was rejected")
      : t("This lead was restored to New");

  const reasonHeader =
    note_type === "rejection_message"
      ? t("Reason for rejection")
      : t("Reason for restoration");

  return (
    <LeadNotesDisplayContainer>
      {modified_by && (
        <InfoBlockExtraSmall
          header={`${modified_by} ${formatDateTime(modified_at)}`}
          content={
            <div style={{ whiteSpace: "pre-wrap" }}>{statusMessage}</div>
          }
        />
      )}
      {message && (
        <InfoBlockExtraSmall
          header={reasonHeader}
          content={<div style={{ whiteSpace: "pre-wrap" }}>{message}</div>}
        />
      )}
      {message_for_buyer && (
        <InfoBlockExtraSmall
          header={t("Message to buyer")}
          content={
            <div style={{ whiteSpace: "pre-wrap" }}>{message_for_buyer}</div>
          }
        />
      )}
    </LeadNotesDisplayContainer>
  );
}
